if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList);
      for (let item of MutationList) {
        if (item.target.classList.contains("css-slider-current")) {
          handleCartDrawerFooterMutation();
          BSS_B2B.observer?.cartSubject?.listenCartCheckout();
        }
        if (item.target.id === "AjaxCartSubtotal") {
          setTimeout(() => {
            cleanLoyaltyPointsValue();
          }, 1000);
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
        if (item.target.classList.contains("cart-item__total")) {
          cleanLoyaltyPointsValue();
        }
        if (item.target.classList.contains("cart__total")) {
          handleCartDrawerFooterMutation();
        }
        if (item.target.className === 'product-price h5 ') {
          updateProductPoint();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  function cleanLoyaltyPointsValue() {
    const element = document.querySelector(
      ".loyalty_points_cart [bss-b2b-cart-price-active] span"
    );
    if (element) {
      const rawText = element.textContent || "";
      const numericValue = rawText.replace(/[^\d]/g, "");
      element.textContent = numericValue;
    }
  }

  function updateProductPoint() {
    const lastSpan = document.querySelector(
      "[bss-b2b-main-product-form] [bss-b2b-product-id] span:last-of-type"
    );

    if (lastSpan) {
      const text = lastSpan.textContent || "";
      const cleanedNumber =
        text.match(/[\d.,]+/g)?.[0]?.replace(/[.,]/g, "") || "";
      const lastStrong = document.querySelector(
        "[bss-b2b-main-product-form] [bss-b2b-product-parent-price] .product-point strong"
      );

      if (lastStrong) {
        lastStrong.textContent = cleanedNumber;
      }
    }
  }

  function bindVariantChangeEvent() {
    const variantInputs = document.querySelectorAll(
      ".product-variant__item input"
    );

    if (variantInputs.length) {
      variantInputs.forEach((item) => {
        item.addEventListener("click", (e) => {
          const productForm = document.querySelector(
            "[bss-b2b-main-product-form]"
          );
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { event: e, productForm }
          );
        });
      });
    }
  }

  async function handleCartDrawerFooterMutation() {
    if (BSS_B2B) {
      const res = await BSS_B2B.storage.productStorage.load();
      if (res) {
        if (
          res.notExistProductIds?.length ||
          res.productIds?.length ||
          res.variantIds?.size
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "LazyProduct",
            "LoadedLazyProduct",
            {
              ...res,
            }
          );
        }
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      cleanLoyaltyPointsValue();
      updateProductPoint();
      bindVariantChangeEvent();
    }, 1800);
  });
}
